
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import ShowCardsStack from "@/components/ShowCardsStack.vue";
import { getRecomendations } from "@/functions/useMovieAPI";
import { Show } from "@/types";

export default defineComponent({
  components: {
    ShowCardsStack,
  },
  setup() {
    const route = useRoute();
    const recommendedShows = ref<Show[]>([]);
    const watchList = ref<Show[]>([]);

    function populateRecommendedMovies(movies: Show[]): void {
      movies.forEach((movie) => {
        recommendedShows.value.push(movie);
      });
    }

    function addToWatchList(): void {
      console.log("add to watch list");
      const movie = recommendedShows.value.pop();
      if (movie === undefined) {
        console.warn("nothing to add to watch list");
        return;
      }
      watchList.value.push(movie);
    }

    function dropMovie(): void {
      console.log("dropped show");
      recommendedShows.value.pop();
    }

    onMounted(() => {
      // TODO Type narrowing and handle bad inputs
      const showId = route.query.id;
      const showType = route.query.type;
      getRecomendations(showId, showType).then((resp) => {
        console.log("Got recomendations", resp);
        populateRecommendedMovies(resp);
      });
    });

    return { recommendedShows, addToWatchList, dropMovie, watchList };
  },
});
